<!-- 计量单位管理 -->
<template>
  <el-card>
    <div class="toolbar">
      <el-button type="primary" @click="onCreateItem()">
        <i class="fas fa-plus"></i> 新增计量单位
      </el-button>
      <div class="former">
        <select2
          v-model="form.GroupID"
          url="basic?type=MeasureUnitGroup"
          labelName="Name"
          placeholder="请选择计量单位分组"
          no-data-text="无类型"
        ></select2
        >&nbsp;
        <el-input
          clearable
          v-model="form['Name|Code:like']"
          placeholder="计量单位名称或编码"
          @keydown.enter.native="onSubmitQuery"
        ></el-input
        >&nbsp;
        <el-button type="primary" @click="onSubmitQuery">
          <i class="fas fa-search"></i>
        </el-button>
      </div>
    </div>
    <el-table
      ref="multipleTable"
      size="medium"
      :data="itemList"
      v-loading="loading"
    >
      <el-table-column
        type="index"
        :index="pager.size * (pager.page - 1) + 1"
        :width="Math.max(48, (pager.size * pager.page).toString().length * 12)"
      ></el-table-column>
      <el-table-column prop="Name" label="计量单位名称"></el-table-column>
      <el-table-column
        prop="Code"
        label="计量单位编码"
        width="140"
      ></el-table-column>
      <el-table-column label="计量单位分组" width="140" prop="GroupID">
        <template slot-scope="{ row }">
          {{ row.Group ? row.Group.Name : "" }}
        </template>
      </el-table-column>
      <el-table-column
        prop="BasicValue"
        label="基准值"
        width="140"
      ></el-table-column>
      <el-table-column prop="Sort" label="排序值" width="140"></el-table-column>
      <el-table-column prop="Remark" label="备注" width="200"></el-table-column>
      <el-table-column width="120" label="操作">
        <template slot-scope="scope">
          <el-button
            type="primary"
            @click.stop="onEditItem(scope.row)"
            title="编辑"
          >
            <i class="fas fa-pencil-alt"></i>
          </el-button>
          <el-button
            type="danger"
            @click.stop="onDeleteItem(scope.row)"
            title="删除"
          >
            <i class="fas fa-trash-alt"></i>
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="clearfix mar-top-10">
      <el-pagination
        class="pull-right"
        @current-change="onChangePage"
        layout="total, prev, pager, next"
        :total="pager.total"
        :current-page="pager.page"
        :page-size="pager.size"
      ></el-pagination>
    </div>
    <item-form
      v-model="item"
      :visible.sync="itemVisible"
      :isEdit="isEdit"
      @form:saved="getItemList"
    />
  </el-card>
</template>

<script>
import ItemForm from "./form.vue";

export default {
  components: {
    ItemForm,
  },
  data() {
    return {
      itemList: [],
      loading: false,
      pager: {
        total: 0,
        page: 1,
        size: 15,
      },
      form: {
        GroupID: "",
        "Name:like": "",
        "Code:like": "",
      },
      item: this.getEmptyItem(),
      itemVisible: false,
      isEdit: false,
    };
  },
  mounted() {
    this.getItemList();
  },
  methods: {
    getItemList() {
      //获取计量单位列表
      this.loading = true;
      this.$axios
        .get("measureunit", {
          params: {
            where: this.form,
            with: ["Group"],
            ...this.pager,
            order:["-sort","name"],
          },
        })
        .then((response) => {
          this.itemList = response.data.data;
          this.pager = _.pick(response.data, "size", "page", "total");
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onSubmitQuery() {
      this.pager.page = 1;
      this.getItemList();
    },
    onChangePage(page) {
      this.pager.page = page;
      this.getItemList();
    },
    onCreateItem() {
      this.item = this.getEmptyItem();
      this.isEdit = false;
      this.itemVisible = true;
    },
    onEditItem(row) {
      this.item = row;
      this.isEdit = true;
      this.itemVisible = true;
    },
    onDeleteItem(row) {
      this.$confirm("确定要删除该计量单位吗？", "提示")
        .then(() => this.$axios.delete(`measureunit/${row.ID}`))
        .then(() => {
          this.getItemList();
          this.$message.success("成功删除");
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        });
    },
    getEmptyItem() {
      return {
        Name: "", //计量单位名称
        Code: "", //计量单位编码
        GroupID: null, //计量单位分组(常量表中)
        BasicValue: 0, //基准值
        Remark: "", //备注
        Sort: 0, //排序
      };
    },
  },
};
</script>
